import { Button, Dialog, Modal, Typography } from '@finam/web-ui-kit';
import React from 'react';
import { IOfferShort } from '../Services/ResponseData';
import { WebService } from '../Services/WebService';
import { TokenContext } from '../TokenContext';
import './Widgets.scss'
import CommunityDescription from './CommunityDescription';
import cn from 'classnames';

interface IState {
    offers: IOfferShort[],
    openGroups: number[]
}

export default class OffersWidget extends React.Component<{}, IState>{
    static contextType?= TokenContext;
    context!: React.ContextType<typeof TokenContext>;
    private wrapperRef: React.RefObject<HTMLDivElement>;

    constructor(props: any) {
        super(props);
        this.state = { offers: [], openGroups: [] };
        this.wrapperRef = React.createRef();
        // this.handleClickOutside = this.handleClickOutside.bind(this);
    }

    componentDidMount() {
        new WebService(this.context.token).GetOffers().then(res => this.setState({ offers: res }));
        // document.addEventListener("mousedown", this.handleClickOutside);
    }

    // componentWillUnmount(): void {
    //     document.removeEventListener("mousedown", this.handleClickOutside);
    // }




    // renderSubitems(parentId: number): JSX.Element {
    //     const suboffers = this.state.offers.filter(o => o.parent == parentId);
    //     return <div className='suboffers-wrapper'>
    //         {suboffers.map((so, i) => <div className='suboffers-item' key={`suboffer_${i}`}>
    //             <div className='offer-title'>{so.description}</div>
    //             <img src={`data:image/jpeg;base64,${so.image64}`} />
    //         </div>)}
    //     </div>
    // }

    renderOfferTab(offerGroup: IOfferShort, index: number): JSX.Element {
        return <div className='offers__tab-item' key={`offerTab${index}`} onClick={_ => this.toggleTab(index)}>
            <div>
                <span className='offers__tab-name'>{offerGroup.name}</span>
                <span className='offers__tab-count'>{`(${offerGroup.offers.length} предложения)`}</span>
            </div>
            {this.state.openGroups.indexOf(index) > -1 && <div className='offers__items'>
                {offerGroup.offers.map((o, i) => this.renderItem(o, i))}
            </div>}
        </div>
    }

    toggleTab(index: number) {
        var newOpenGroup = [...this.state.openGroups];
        var openIndex = newOpenGroup.indexOf(index);
        if (openIndex > -1) {
            newOpenGroup.splice(openIndex, 1);
        }
        else {
            newOpenGroup.push(index);
        }
        this.setState({ openGroups: newOpenGroup });
    }

    renderItem(offer: any, index: number): JSX.Element {
        return <div className='offer-item__item' key={`offer${index}`}>
            <div className='imageWrapper'>
                <img src={`data:image/jpeg;base64,${offer.image64}`} />
            </div>
            <div className='offer-title'>{offer.description}</div>
        </div>
    }

    render(): React.ReactNode {
        return <div className='offers__wrapper' ref={this.wrapperRef}>
            <div className='offers__tab'>
                {this.state.offers.map((group, i) => this.renderOfferTab(group, i))}
            </div>
            {/* {this.state.offers.filter(o => o.parent == 0).map((item, i) => this.renderItem(item, i))} */}
        </div>

    }

    // handleClickOutside(event: any) {
    //     if (this.state?.selectedId && this.state?.selectedId > 0) {
    //         if (this.wrapperRef && !this.wrapperRef.current?.contains(event.target)) {
    //             //alert('Test');
    //             this.setState({ selectedId: 0 });
    //         }
    //      }
    // }
}